module.exports = __webpack_public_path__ + "img/logo-white.6f2b30b2.svg";